import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { MODULE } from '@modules/types';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const AutomaticCampaigns = Suspendable(
  lazy(() =>
    import('@modules/automaticCampaigns/controller/CampaignsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const Campaign = Suspendable(
  lazy(() =>
    import('@modules/automaticCampaigns/submodules/campaign/controller/CampaignController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const AutomaticCampaignRoutes: RouteObject[] = [
  {
    path: ROUTES.AUTOMATIC_CAMPAIGNS.ROOT,
    element: <AutomaticCampaigns module={MODULE.AUTOMATIC_CAMPAIGN} />,
  },
  {
    path: ROUTES.CAMPAIGN_MANAGEMENT.ROOT,
    element: <AutomaticCampaigns module={MODULE.CAMPAIGN} />,
  },
  {
    path: ROUTES.CAMPAIGN_MANAGEMENT.CREATE,
    element: <Campaign mode="create" module={MODULE.CAMPAIGN} />,
  },
  {
    path: ROUTES.CAMPAIGN_MANAGEMENT.EDIT,
    element: <Campaign mode="edit" module={MODULE.CAMPAIGN} />,
  },
  {
    path: ROUTES.CAMPAIGN_MANAGEMENT.CLONE,
    element: <Campaign mode="clone" module={MODULE.CAMPAIGN} />,
  },
  {
    path: ROUTES.AUTOMATIC_CAMPAIGNS.CREATE,
    element: <Campaign mode="create" module={MODULE.AUTOMATIC_CAMPAIGN} />,
  },
  {
    path: ROUTES.AUTOMATIC_CAMPAIGNS.EDIT,
    element: <Campaign mode="edit" module={MODULE.AUTOMATIC_CAMPAIGN} />,
  },
  {
    path: ROUTES.AUTOMATIC_CAMPAIGNS.CLONE,
    element: <Campaign mode="clone" module={MODULE.AUTOMATIC_CAMPAIGN} />,
  },
];
